<div class="ion-padding">
  <ion-row>
    <ion-col size="12" sizeMd="6">
      <h2><ion-icon name="calendar"></ion-icon> Közelgő határnapok</h2>
      <ion-list lines="full">
        <ion-item *ngIf="hatarnapok.length === 0"><ion-label color="medium">Nincs közelgő határnap (60 nap).</ion-label></ion-item>
        <ion-item button *ngFor="let h of hatarnapok" (click)="ugyhoz(h.ugy_id)">
          <ion-badge slot="start" [color]="szin(h.datum)">{{ h.datum }}</ion-badge>
          <ion-label>
            <h3>{{ h.megnevezes }}</h3>
            <p>{{ h.ugyazonosito }} — {{ h.ugy_leiras }}<span *ngIf="h.idopont"> · {{ h.idopont }}</span><span *ngIf="h.hely"> · {{ h.hely }}</span></p>
          </ion-label>
        </ion-item>
      </ion-list>
    </ion-col>
    <ion-col size="12" sizeMd="6">
      <h2><ion-icon name="checkbox"></ion-icon> Nyitott tennivalók</h2>
      <ion-list lines="full">
        <ion-item *ngIf="tennivalok.length === 0"><ion-label color="medium">Nincs nyitott tennivaló.</ion-label></ion-item>
        <ion-item *ngFor="let t of tennivalok">
          <ion-checkbox slot="start" (ionChange)="tennivaloKesz(t)"></ion-checkbox>
          <ion-label (click)="ugyhoz(t.ugy_id)" style="cursor:pointer">
            <h3>{{ t.szoveg }}</h3>
            <p><ion-badge [color]="szin(t.datum)" *ngIf="t.datum">{{ t.datum }}</ion-badge> {{ t.ugyazonosito }} — {{ t.ugy_leiras }}<span *ngIf="t.felelos"> · {{ t.felelos }}</span></p>
          </ion-label>
        </ion-item>
      </ion-list>
    </ion-col>
  </ion-row>
</div>
